import { itemSubmitRetractionRequest } from "~/store/graphql/mutations/itemSubmitRetractionRequest.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const submitRequestRetraction = async function ({ commit, state }) {
  const id = state.retractionItem.id;
  const reason = state.retractionItem.retraction.request.reason;
  const acceptsRetractionTerms =
    state.retractionItem.retraction.request.acceptsRetractionTerms;

  const data = await runGraphQLQuery(
    itemSubmitRetractionRequest,
    {
      id,
      reason,
      acceptsRetractionTerms,
    },
    this.$axios
  );

  if (data) {
    commit("SET_RETRACTION_UPDATE", data);

    return Promise.resolve(data);
  }
};

export default submitRequestRetraction;
